import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SystemVarsRestService } from '@gh/builder-shared-data';
import { NotificationService } from '@gh/core-ui';

@Injectable({
  providedIn: 'root'
})
export class BillingInvoicesRedirectBusinessService {

	constructor(
		private systemVarsRest: SystemVarsRestService,
		private notificationService: NotificationService
	) {}

	/**
	 * Creates Stripe subscription session for customer portal
	 * @returns {Observable<{customerPortalSessionUrl: string}>}
	 */
	createStripeSubscriptionSession(officeCode?: string): Observable<{ customerPortalSessionUrl: string }> {
		return this.systemVarsRest.createStripeSubscriptionSession(officeCode);
	}

  /**
   * Redirects to the Stripe customer portal based on the subscription session URL.
   */
  redirectToBilling(officeCode?: string): void {
    this.createStripeSubscriptionSession(officeCode).subscribe({
      next: (response: { customerPortalSessionUrl: string }) => {
        if (response && response.customerPortalSessionUrl) {
          window.open(response.customerPortalSessionUrl, '_blank');
        } else {
          this.handleError('msg_office_no_active_subscription');
        }
      },
      error: () => {
        this.handleError('msg_failed_open_subscription_management');
      },
    });
  }

  private handleError(message: string): void {
    this.notificationService.error(message);
  }
}


